import request from '@/utils/request'

/**
 * 获取token
 * @param params 有效时长 毫秒
 */
export const getToken = (params) => {
    return new request({
        url: './auth/getToken',
        method: 'get',
        params:params
    });
}